import React, { TextareaHTMLAttributes } from 'react';
import * as classes from '../Input/Input.module.scss';
import InputWrapper, { InputWrapperProps } from '../Input/Wrapper/InputWrapper';
import cn from 'classnames';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement>, InputWrapperProps {
  className?: string;
}

function TextArea(props: TextAreaProps) {
  const { className, touched, error, errorBoundary, wrapperClassName, messageClassName, counting, length, isReq, ...rest } = props;

  const inputClassName = cn(className, !!touched && !!error && errorBoundary && classes.inputErrorBorder);
  return (
    <InputWrapper
      wrapperClassName={wrapperClassName}
      messageClassName={messageClassName}
      counting={counting}
      length={length}
      isReq={isReq}
      {...props}
    >
      <textarea className={inputClassName} {...rest} />
    </InputWrapper>
  );
}

export default TextArea;
